"use client";

import React from "react";
import EditSection, { TextEditor, ListItemEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function UniversityBlogEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  const defaultPosts = [
    { title: "Those inequalities are inequalities that occur within households", author: "Samira Khan", date: "November 28, 2023", link: "#" },
    { title: "Those inequalities are inequalities that occur within households", author: "Zent Ekizie", date: "November 28, 2023", link: "#" },
    { title: "After decades of improvement, cardiovascular health rates", author: "Zayed Khan", date: "November 28, 2023", link: "#" },
  ];

  const defaultBigPost = {
    title: "Classroom community-building — It's ok to try something new!",
    author: "Masum Sakib",
    date: "November 28, 2023",
    link: "#",
  };

  const bigPost = content.bigPost || defaultBigPost;

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Section Headers</h4>
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => handleChange({ ...content, title: v })}
              placeholder="Latest News & Blog"
            />
            <TextEditor
              label="Subtitle"
              value={content.subtitle}
              onChange={(v) => handleChange({ ...content, subtitle: v })}
              placeholder="Stay updated with our latest news and events..."
            />
            <TextEditor
              label="View All Link URL"
              value={content.viewAllLink || ""}
              onChange={(v) => handleChange({ ...content, viewAllLink: v })}
              placeholder="#"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Featured (Big) Blog Post</h4>
            <TextEditor
              label="Featured Image URL"
              value={content.bigImage || ""}
              onChange={(v) => handleChange({ ...content, bigImage: v })}
              placeholder="https://images.unsplash.com/..."
            />
            <TextEditor
              label="Title"
              value={bigPost.title}
              onChange={(v) => handleChange({ ...content, bigPost: { ...bigPost, title: v } })}
              placeholder="Community Building"
            />
            <TextEditor
              label="Author Name"
              value={bigPost.author}
              onChange={(v) => handleChange({ ...content, bigPost: { ...bigPost, author: v } })}
              placeholder="Masum Sakib"
            />
            <TextEditor
              label="Published Date"
              value={bigPost.date}
              onChange={(v) => handleChange({ ...content, bigPost: { ...bigPost, date: v } })}
              placeholder="November 28, 2023"
            />
            <TextEditor
              label="Link URL"
              value={bigPost.link}
              onChange={(v) => handleChange({ ...content, bigPost: { ...bigPost, link: v } })}
              placeholder="#"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Secondary Blog Posts</h4>
            <ListItemEditor
              label="Posts"
              items={content.posts || defaultPosts}
              itemSchema={[
                { key: "title", label: "Post Title", type: "text" },
                { key: "author", label: "Author", type: "text" },
                { key: "date", label: "Published Date", type: "text" },
                { key: "link", label: "Link URL", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, posts: items })}
              addItemText="Add Blog Post"
            />
          </div>
        </div>
      }
    />
  );
}
